// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Menu-module--cls1--MAwg1","cls2":"styles-Menu-module--cls2--1_hst styles-Menu-module--cls1--MAwg1","leftSide":"styles-Menu-module--leftSide--1XpGG"};